 /* eslint-disable */
// this is an auto generated file. This will be overwritten
export const getEmsGiftAwayTransaction = /* GraphQL */ `
  query GetEmsGiftAwayTransaction($id: ID!) {
    getEmsGiftAwayTransaction(id: $id) {
      brand_code
      catalog_name
      create_date
      credits_balance
      credits_used
      deducted_amount
      denomination
      expiry_date_time
      gift_status
      id
      merchant_id
      modify_date
      order_id
      product_id
      reference_no
      status
      urls
      winloss_status
    }
  }
`;
export const getEmsGiftAwayTransactionIndexTable = /* GraphQL */ `
  query GetEmsGiftAwayTransactionIndexTable($pid: String!, $tdate: String!) {
    getEmsGiftAwayTransactionIndexTable(pid: $pid, tdate: $tdate) {
      losses
      pendings
      pid
      tdate
      wins
    }
  }
`;
export const getEmsGiftAwayTransactionUserIndexTable = /* GraphQL */ `
  query GetEmsGiftAwayTransactionUserIndexTable($uid: String!) {
    getEmsGiftAwayTransactionUserIndexTable(uid: $uid) {
      losses
      pendings
      uid
      wins
    }
  }
`;
export const getEmsS3Object = /* GraphQL */ `
  query GetEmsS3Object($id: ID!) {
    getEmsS3Object(id: $id) {
      bucket
      cdnUrl
      contentLength
      id
      key
      s3Url
    }
  }
`;
export const listEmsGiftAwayTransactionIndexTables = /* GraphQL */ `
  query ListEmsGiftAwayTransactionIndexTables(
    $filter: TableEmsGiftAwayTransactionIndexTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmsGiftAwayTransactionIndexTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        losses
        pendings
        pid
        tdate
        wins
      }
      nextToken
    }
  }
`;
export const listEmsGiftAwayTransactionIndexTablesByRangeDate = /* GraphQL */ `
  query ListEmsGiftAwayTransactionIndexTablesByRangeDate(
    $end_date: String!
    $filter: TableEmsGiftAwayTransactionIndexTableFilterInput
    $limit: Int
    $nextToken: String
    $pid: String!
    $start_date: String!
  ) {
    listEmsGiftAwayTransactionIndexTablesByRangeDate(
      end_date: $end_date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pid: $pid
      start_date: $start_date
    ) {
      items {
        losses
        pendings
        pid
        tdate
        wins
      }
      nextToken
    }
  }
`;
export const listEmsGiftAwayTransactionUserIndexTables = /* GraphQL */ `
  query ListEmsGiftAwayTransactionUserIndexTables(
    $filter: TableEmsGiftAwayTransactionUserIndexTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmsGiftAwayTransactionUserIndexTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        losses
        pendings
        uid
        wins
      }
      nextToken
    }
  }
`;
export const listEmsGiftAwayTransactions = /* GraphQL */ `
  query ListEmsGiftAwayTransactions($filter: FilterGiftAwayTransaction) {
    listEmsGiftAwayTransactions(filter: $filter) {
      brand_code
      catalog_name
      create_date
      credits_balance
      credits_used
      deducted_amount
      denomination
      expiry_date_time
      gift_status
      id
      merchant_id
      modify_date
      order_id
      product_id
      reference_no
      status
      urls
      winloss_status
    }
  }
`;
export const listEmsGiftAwayTransactionsPagination = /* GraphQL */ `
  query ListEmsGiftAwayTransactionsPagination(
    $filter: FilterGiftAwayTransaction
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsGiftAwayTransactionsPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        brand_code
        catalog_name
        create_date
        credits_balance
        credits_used
        deducted_amount
        denomination
        expiry_date_time
        gift_status
        id
        merchant_id
        modify_date
        order_id
        product_id
        reference_no
        status
        urls
        sitefinity_user_id
        winloss_status
        product_type_id
      }
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const listEmsGiftAwayTransactionsSummary = /* GraphQL */ `
  query ListEmsGiftAwayTransactionsSummary(
    $start_date: String!
    $end_date: String!
    $brand_code: String
  ) {
    listEmsGiftAwayTransactionsSummary(
      start_date: $start_date
      end_date: $end_date
      brand_code: $brand_code
    ) {
      brand_code
      date
      count
      countWin
      countLoss
      countSuccessRedeem
      creditsUsed
      totalItems
    }
  }
`;
export const exportEmsGiftAwayTransactions = /* GraphQL */ `
  query ExportEmsGiftAwayTransactions($filter: FilterGiftAwayTransaction) {
    exportEmsGiftAwayTransactions(filter: $filter)
  }
`;
export const listEmsGiftAwayTransactionsByBrandCodeIndex = /* GraphQL */ `
  query ListEmsGiftAwayTransactionsByBrandCodeIndex(
    $brand_code: String!
    $end_date: String!
    $filter: TableEmsGiftAwayTransactionFilterInput
    $limit: Int
    $nextToken: String
    $start_date: String!
  ) {
    listEmsGiftAwayTransactionsByBrandCodeIndex(
      brand_code: $brand_code
      end_date: $end_date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      start_date: $start_date
    ) {
      items {
        brand_code
        catalog_name
        create_date
        credits_balance
        credits_used
        deducted_amount
        denomination
        expiry_date_time
        gift_status
        id
        merchant_id
        modify_date
        order_id
        product_id
        reference_no
        status
        urls
        winloss_status
      }
      nextToken
    }
  }
`;
export const listEmsGiftAwayTransactionsByReferenceNoIndex = /* GraphQL */ `
  query ListEmsGiftAwayTransactionsByReferenceNoIndex(
    $limit: Int
    $nextToken: String
    $reference_no: String!
  ) {
    listEmsGiftAwayTransactionsByReferenceNoIndex(
      limit: $limit
      nextToken: $nextToken
      reference_no: $reference_no
    ) {
      items {
        brand_code
        catalog_name
        create_date
        credits_balance
        credits_used
        deducted_amount
        denomination
        expiry_date_time
        gift_status
        id
        merchant_id
        modify_date
        order_id
        product_id
        reference_no
        status
        urls
        winloss_status
      }
      nextToken
    }
  }
`;
export const listEmsLASDonationPagination = /* GraphQL */ `
  query ListEmsLASDonationPagination(
    $filter: FilterEmsLASDonation
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsLASDonationPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        raffle_id
        promo_id
        rules_id
        rules_name
        donated_amount
        donation_date
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const listEmsTrackingUPCMultiplyRecordPagination = /* GraphQL */ `
  query ListEmsTrackingUPCMultiplyRecordPagination(
    $filter: FilterEmsTrackingUPCMultiply
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsTrackingUPCMultiplyRecordPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        raffle_id
        brand_code
        campaign_id
        campaign_type
        pack_code
        selected_option
        upc_count
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const listEmsLASActivityRewardTransactionsPagination = /* GraphQL */ `
  query ListEmsLASActivityRewardTransactionsPagination(
    $filter: FilterEmsLASActivityRewardTransaction
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsLASActivityRewardTransactionsPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        transaction_id
        reference_no
        brand_code
        profile_id
        sitefinity_user_id
        transaction_type
        transaction_name
        prize_type
        prize_id
        prize_name
        prize_value
        claim_status
        create_date_utc
        modify_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportLASDonation = /* GraphQL */ `
  query ExportLASDonation(
    $filter: FilterEmsLASDonation 
    $filename: String ) {
    exportLASDonation(
      filter: $filter
      filename: $filename)
  }
`;
export const exportEmsTrackingUPCMultiplyRecord = /* GraphQL */ `
  query exportEmsTrackingUPCMultiplyRecord(
    $filter: FilterEmsTrackingUPCMultiply
    $filename: String ) {
      exportEmsTrackingUPCMultiplyRecord(
      filter: $filter
      filename: $filename)
  }
`;
export const exportLASActivityRewardTransactions = /* GraphQL */ `
  query ExportLASActivityRewardTransactions(
    $filter: FilterEmsLASActivityRewardTransaction 
    $filename: String ) {
    exportLASActivityRewardTransactions(
      filter: $filter
      filename: $filename)
  }
`;
export const listEmsUGCArtworkVotesPagination = /* GraphQL */ `
  query listEmsUGCArtworkVotesPagination(
    $filter: FilterEmsUGCArtworkVotes
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsUGCArtworkVotesPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        user_raffle_id
        campaign_id
        campaign_name
        contest_id
        content_id
        content_name
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportUGCArtworkVotes = /* GraphQL */ `
  query exportUGCArtworkVotes(
    $filter: FilterEmsUGCArtworkVotes 
    $filename: String ) {
      exportUGCArtworkVotes(
      filter: $filter
      filename: $filename)
  }
`;
export const listEmsUGCArtworkContestPagination = /* GraphQL */ `
  query listEmsUGCArtworkContestPagination(
    $filter: FilterEmsUGCArtworkContest
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsUGCArtworkContestPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        uploader_user_raffle_id
        campaign_id
        vote_campaign_id
        content_name
        content_description
        s3_url
        is_publishing_approved
        is_vote_approved
        publish_approved_date
        vote_approved_date
        approved_voters
        number_of_votes
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportUGCArtworkContest = /* GraphQL */ `
  query exportUGCArtworkContest(
    $filter: FilterEmsUGCArtworkContest 
    $filename: String ) {
      exportUGCArtworkContest(
      filter: $filter
      filename: $filename)
  }
`;

export const listUPCTransactionPagination = /* GraphQL */ `
  query listUPCTransactionPagination(
    $filter: FilterUPCTransaction
    $pageSize: Int
    $pageNumber: Int
  ) {
    listUPCTransactionPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        transaction_id
        brand_code
        user_raffle_id
        promo_id 
        promo_type
        pack_code 
        pack_item 
        pack_itemDesc 
        brand_family 
        brand_family_desc 
        brand_family_setting 
        sub_brand_family_setting 
        status 
        campaign_id 
        campaign_name 
        campaign_description 
        promosys_status
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;

export const exportUPCTransaction = /* GraphQL */ `
  query exportUPCTransaction(
    $filter: FilterUPCTransaction 
    $filename: String ) {
      exportUPCTransaction(
      filter: $filter
      filename: $filename)
  }
`;

export const listUPCLASClassificationPagination = /* GraphQL */ `
  query listUPCLASClassificationPagination(
    $filter: FilterUPCLASClassification
    $pageSize: Int
    $pageNumber: Int
  ) {
    listUPCLASClassificationPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        brand_code
        upc_transaction_id
        user_raffle_id
        user_classification 
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportUPCLASClassification = /* GraphQL */ `
  query exportUPCLASClassification(
    $filter: FilterUPCLASClassification 
    $filename: String ) {
      exportUPCLASClassification(
      filter: $filter
      filename: $filename)
  }
`;


export const listAffiliatorReferralCodePagination = /* GraphQL */ `
  query listAffiliatorReferralCodePagination(
    $filter: FilterAffiliatorReferralCode
    $pageSize: Int
    $pageNumber: Int
  ) {
    listAffiliatorReferralCodePagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        affiliator_raffle_id
        referral_code
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportAffiliatorReferralCode = /* GraphQL */ `
  query exportAffiliatorReferralCode(
    $filter: FilterAffiliatorReferralCode 
    $filename: String ) {
      exportAffiliatorReferralCode(
      filter: $filter
      filename: $filename)
  }
`;

export const listUPCConsumerBlockPagination = /* GraphQL */ `
  query FilterUPCConsumerBlock(
    $filter: FilterUPCConsumerBlock
    $pageSize: Int
    $pageNumber: Int
  ) {
    listUPCConsumerBlockPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        promo_id
        promotion_type
        user_raffle_id
        block_time_limit_utc
        block_type
        block_reason
        is_unlocked
        unblock_by_user
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportUPCConsumerBlock = /* GraphQL */ `
  query exportUPCConsumerBlock(
    $filter: FilterUPCConsumerBlock 
    $filename: String ) {
      exportUPCConsumerBlock(
      filter: $filter
      filename: $filename)
  }
`;

export const listReferralUsersPagination = /* GraphQL */ `
  query listReferralUsersPagination(
    $filter: FilterReferralUsers
    $pageSize: Int
    $pageNumber: Int
  ) {
    listReferralUsersPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        brand_code
        transaction_id
        affiliator_raffle_id
        referee_raffle_id
        major_campaign_id
        minor_campaign_id
        status
        registration_date_utc
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportReferralUsers = /* GraphQL */ `
  query exportReferralUsers(
    $filter: FilterReferralUsers 
    $filename: String ) {
      exportReferralUsers(
      filter: $filter
      filename: $filename)
  }
`;


export const listEMSAuditTrailAPIPagination = /* GraphQL */ `
  query listEMSAuditTrailAPIPagination(
    $filter: FilterEMSAuditTrailAPI
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEMSAuditTrailAPIPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        ip_address
        user_identifier
        header
        body
        parameter
        execution_time_in_miliseconds
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportEMSAuditTrailAPI = /* GraphQL */ `
  query exportEMSAuditTrailAPI(
    $filter: FilterEMSAuditTrailAPI 
    $filename: String ) {
      exportEMSAuditTrailAPI(
      filter: $filter
      filename: $filename)
  }
`;
export const listEmsBlockUserAPIPagination = /* GraphQL */ `
  query listEmsBlockUserAPIPagination(
    $filter: FilterEmsBlockUserAPI
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsBlockUserAPIPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        user
        ip_address
        header
        detail
        is_block
        block_type
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportEmsBlockUserAPI = /* GraphQL */ `
  query exportEmsBlockUserAPI(
    $filter: FilterEmsBlockUserAPI 
    $filename: String ) {
      exportEmsBlockUserAPI(
      filter: $filter
      filename: $filename)
  }
`;

export const listEmsGlobalPromoTransactionPagination = /* GraphQL */ `
  query listEmsGlobalPromoTransactionPagination(
    $filter: FilterEmsGlobalPromoTransaction
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsGlobalPromoTransactionPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        promo_id
        action_id
        raffle_id
        promotion_type
        reward_status
        create_date
        modify_date
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportEmsGlobalPromoTransaction = /* GraphQL */ `
  query exportEmsGlobalPromoTransaction(
    $filter: FilterEmsGlobalPromoTransaction 
    $filename: String ) {
      exportEmsGlobalPromoTransaction(
      filter: $filter
      filename: $filename)
  }
`;
export const listEmsS3Objects = /* GraphQL */ `
  query ListEmsS3Objects(
    $filter: TableEmsS3ObjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmsS3Objects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        bucket
        cdnUrl
        contentLength
        id
        key
        s3Url
      }
      nextToken
    }
  }
`;

export const listEmsSchedulerProcessPagination = /* GraphQL */ `
    query listEmsSchedulerProcessPagination(
        $filter: FilterEmsSchedulerProcess
        $pageSize: Int
        $pageNumber: Int
    ) {
        listEmsSchedulerProcessPagination(
            filter: $filter
            pageSize: $pageSize
            pageNumber: $pageNumber
        ) {
            items {
                id
                brand_code
                last_sync_date
                process_category
                sub_process_category
                created_date_utc
                modified_date_utc
            }
            totalItems
            totalPages
            currentPage
        }
    }
`;

export const listEmsSchedulerReProcessPagination = /* GraphQL */ `
    query listEmsSchedulerReProcessPagination(
        $filter: FilterEmsSchedulerReProcess
        $pageSize: Int
        $pageNumber: Int
    ) {
        listEmsSchedulerReProcessPagination(
            filter: $filter
            pageSize: $pageSize
            pageNumber: $pageNumber
        ) {
            items {
                id
                brand_code
                start_date
                end_date
                reprocess
                process_category
                sub_process_category
                is_process_complete
                created_date_utc
                modified_date_utc
            }
            totalItems
            totalPages
            currentPage
        }
    }
`;

export const exportEmsSchedulerProcess = /* GraphQL */ `
    query exportEmsSchedulerProcess(
        $filter: FilterEmsSchedulerProcess
        $filename: String
    ) {
        exportEmsSchedulerProcess(filter: $filter, filename: $filename)
    }
`;

export const exportEmsSchedulerReProcess = /* GraphQL */ `
    query exportEmsSchedulerReProcess(
        $filter: FilterEmsSchedulerReProcess
        $filename: String
    ) {
        exportEmsSchedulerReProcess(filter: $filter, filename: $filename)
    }
`;

export const listEmsContentViewPagination = /* GraphQL */ `
  query listEmsContentViewPagination(
    $filter: FilterEmsContentView
    $pageSize: Int
    $pageNumber: Int
  ) {
    listEmsContentViewPagination(
      filter: $filter
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        id
        brand_code
        profile_id
        content_id
        content_type
        content_name
        created_date_utc
        modified_date_utc
      }      
      totalItems
      totalPages
      currentPage
    }
  }
`;
export const exportEmsContentView = /* GraphQL */ `
  query exportEmsContentView(
    $filter: FilterEmsContentView
    $filename: String ) {
      exportEmsContentView(
      filter: $filter
      filename: $filename)
  }
`;